import { render } from "./AdminViewReportsApproved.vue?vue&type=template&id=be91fe22"
import script from "./AdminViewReportsApproved.vue?vue&type=script&lang=js"
export * from "./AdminViewReportsApproved.vue?vue&type=script&lang=js"

import "./AdminViewReportsApproved.vue?vue&type=style&index=0&id=be91fe22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__